import { Pencil } from "lucide-react";

export default function DriverChargesBoard({
  rows = [],
  onEditDriver, // (driverCode) => open modal
}) {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
      {rows.length === 0 ? (
        <div className="col-span-full border rounded-md bg-white p-6 text-sm text-gray-600 text-center">
          No driver charges found.
        </div>
      ) : (
        rows.map((r) => (
          <div key={r.driverCode} className="border rounded-xl bg-white shadow-sm overflow-hidden">
            <div className="flex items-center justify-between px-4 py-3 border-b bg-gray-50">
              <div>
                <div className="text-sm font-semibold text-gray-900">
                  {r.driverCode} • {r.name || "—"}
                </div>
                <div className="text-xs text-gray-600">{r.teamName || "—"}</div>
              </div>

              <button
                className="inline-flex items-center gap-2 px-3 py-1.5 rounded bg-orange-600 hover:bg-orange-700 text-white text-xs shadow"
                onClick={() => onEditDriver?.(r.driverCode)}
                title="Edit Charges"
              >
                <Pencil size={14} />
                Edit
              </button>
            </div>

            <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-3">
              <ChargeCard
                title="Per Day"
                type="per_day"
                amount={r.per_day?.amount}
                exists={!!r.per_day?.id}
              />
              <ChargeCard
                title="Per Order"
                type="per_order"
                amount={r.per_order?.amount}
                exists={!!r.per_order?.id}
              />
            </div>
          </div>
        ))
      )}
    </div>
  );
}

function ChargeCard({ title, type, amount, exists }) {
  return (
    <div className="rounded-xl border bg-white p-4">
      <div className="flex items-center justify-between">
        <div className="text-xs font-semibold text-gray-700">{title}</div>
        <span
          className={[
            "text-[11px] px-2 py-1 rounded-full",
            exists ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-700",
          ].join(" ")}
        >
          {exists ? "Configured" : "Not Set"}
        </span>
      </div>

      <div className="mt-2">
        <div className="text-[11px] text-gray-500">Type</div>
        <div className="text-sm font-semibold text-gray-900">{type}</div>
      </div>

      <div className="mt-2">
        <div className="text-[11px] text-gray-500">Amount</div>
        <div className="text-lg font-bold text-gray-900">
          {amount === null || amount === undefined || amount === "" ? "—" : amount}
        </div>
      </div>
    </div>
  );
}
